import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import OrdersTable from "components/Tables/OrdersTable";
import TotalStatsCard from "components/Cards/TotalStatsCard";
import DiscountStatsCard from "components/Cards/DiscountStatsCard";
import OrdersStatsCard from "components/Cards/OrdersStatsCard";
import PeopleStatsCard from "components/Cards/PeopleStatsCard";
import PayedStatsCard from "components/Cards/PayedStatsCard";
import OpenStatsCard from "components/Cards/OpenStatsCard";
import CancelledStatsCard from "components/Cards/CancelledStatsCard";
import DestroyedStatsCard from "components/Cards/DestroyedStatsCard";

function OrderStatsPage() {
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [income, setIncome] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [orders, setOrders] = useState(0);
  const [people, setPeople] = useState(0);
  const [payed, setPayed] = useState(0);
  const [open, setOpen] = useState(0);
  const [destroyed, setDestroyed] = useState(0);
  const [count, setCount] = useState(0);
  const [cancelled, setCancelled] = useState(0);

  const handleTableData = (data) => {
    if (!data) return;
    setIncome(data.income ? data.income : 0);
    setDiscount(data.discount ? data.discount : 0);
    setOrders(data.orders ? data.orders : 0);
    setPeople(data.people ? data.people : 0);
    setPayed(data.payed ? data.payed : 0);
    setOpen(data.open ? data.open : 0);
    setCancelled(data.cancelled ? data.cancelled : 0);
    setDestroyed(data.destroyed ? data.destroyed : 0);
    setCount(data.count ? data.count : 0);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="3" xs="12" sm="12">
            <TotalStatsCard totals={income} />
          </Col>
          <Col lg="3" sm="12">
            <DiscountStatsCard discounts={discount} />
          </Col>
          <Col lg="3" sm="12" xs="12">
            <OrdersStatsCard orders={count} />
          </Col>
          <Col lg="3" sm="12" xs="12">
            <PeopleStatsCard people={people} />
          </Col>
        </Row>
        <Row>
          <Col lg="3" xs="12" sm="12">
            <PayedStatsCard payed={payed} />
          </Col>
          <Col lg="3" sm="12">
            <OpenStatsCard open={open} />
          </Col>
          <Col lg="3" sm="12" xs="12">
            <CancelledStatsCard cancelled={cancelled} />
          </Col>
          <Col lg="3" sm="12" xs="12">
            <DestroyedStatsCard destroyed={destroyed} />
          </Col>
        </Row>
        <Row>
          <Col lg="12" sm="12" md="12">
            <OrdersTable sendData={handleTableData} />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default OrderStatsPage;
